// options.source for the 369.dev booking calendar the demo dialog mounts
// (W369Booking.mount/open, lead source part A): where this demo lead came from, stored on
// the booking and its new client. Built from the same touch data the demo form sends,
// consent-gated the same way: the session touch is always sent with click ids only under
// granted ad consent, first and last touch only under granted ad consent. 369.dev drops
// any field it doesn't list, so add fields there first. Pure: unit tested in
// tests/tracking/bookingSource.test.ts.
import type { AdConsentValue, AttributionState } from './attributionCookie.ts';
import { sessionTouchForLead, type SessionTouch } from './sessionTouch.ts';

export const BOOKING_SOURCE_SITE = 'workspace369.com';
export const BOOKING_SOURCE_FORM = 'demo-dialog';

export function buildBookingSource(
  adConsent: AdConsentValue,
  sessionTouch: SessionTouch | null,
  attribution: AttributionState | null,
) {
  const granted = adConsent === 'granted';
  return {
    site: BOOKING_SOURCE_SITE,
    form: BOOKING_SOURCE_FORM,
    ad_consent: adConsent,
    session_touch: sessionTouchForLead(sessionTouch, adConsent),
    first_touch: granted ? (attribution?.first ?? null) : null,
    last_touch: granted ? (attribution?.last ?? null) : null,
  };
}
